import React from 'react'
import PropTypes from 'prop-types'
import { ResponsiveIframe } from 'scripts/helpers/AppHelper'
import queryString from 'querystring'

const VikiHeroIframe = (props) => {
  const { src } = props
  const vikiOptions = {
    autostart: 'true',
    autoplay: 'true'
  }
  const vikiOptionQueryString = queryString.stringify(vikiOptions)
  const splittedSrc = src.split('?')

  let finalSrc = ''
  if (splittedSrc.length > 0) {
    finalSrc = `${splittedSrc[0]}?${vikiOptionQueryString}`
  }

  return (
    <div className='article-iframe-hero'>
      <ResponsiveIframe src={ finalSrc } allow="autoplay; fullscreen" allowFullScreen="true"></ResponsiveIframe>
    </div>
  )
}
export default VikiHeroIframe

VikiHeroIframe.propTypes = {
  src: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./assets/js/components/article/HeroIframe/VikiHeroIframe.jsx